import { CASES } from './constants';
import {
    PAGINATION_STORAGE_KEYS,
    DEFAULT_PAGE_SIZE_OPTIONS,
    getStoredItemsPerPage,
    getInitialPaginationRange,
    withPreservedPagination,
    persistItemsPerPage,
} from 'datastage/utils/paginationPreferences.js';

const getInitialJobsSort = () => {
    const saved = localStorage.getItem('jobSort');
    return saved ? JSON.parse(saved) : ['id', 'DESC'];
};

/**
 * Gets the initial items per page from localStorage.
 * Falls back to 20 (Jobs default) if not found.
 */
const getInitialItemsPerPage = () => {
    return getStoredItemsPerPage(PAGINATION_STORAGE_KEYS.jobs, 20);
};

// Initialize with stored preference
const initialItemsPerPage = getInitialItemsPerPage();

/**
 * Initial state for the jobs slice.
 *
 * Key state values:
 * - jobs: Array of job objects for the grid
 * - filterForm: Search form field values
 * - refreshJobs: Boolean flag to trigger grid refresh from other components
 * - itemsPerPage: User's persisted page size preference (from localStorage)
 */
const initialState = {
    jobs: [],
    filterForm: {
        jobId: '',
        jobType: '',
        dealId: '',
        jobStatus: '',
        startDate: '',
        endDate: '',
    },
    jobStatusOptions: [],
    jobTypeOptions: [],
    totalPages: 0,
    totalItems: 0,
    currentPage: 0,
    filterParam: '',
    jobRange: getInitialPaginationRange(initialItemsPerPage),
    jobSort: getInitialJobsSort(),
    defaultFilterRange: getInitialPaginationRange(initialItemsPerPage),
    itemsPerPage: initialItemsPerPage,
    pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
    // Flag to trigger grid refresh from other components
    refreshJobs: false,
};

export function jobs(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case CASES.UPDATE_JOBS: {
            // Persist sort preference to localStorage
            if (payload.jobSort) {
                localStorage.setItem('jobSort', JSON.stringify(payload.jobSort));
            }
            // Persist page size preference to localStorage
            if (payload.itemsPerPage !== undefined) {
                persistItemsPerPage(PAGINATION_STORAGE_KEYS.jobs, payload.itemsPerPage);
            }
            return { ...state, ...payload };
        }
        case CASES.UPDATE_JOBS_SEARCH_FORM: {
            const { data, key } = payload;
            return { ...state, [key]: { ...state[key], ...data } };
        }
       case CASES.CLEAR_JOBS: {
           // Preserve pagination preferences when clearing
           return withPreservedPagination(
               state,
               {
                   ...initialState,
                   jobStatusOptions: state.jobStatusOptions,
                   jobTypeOptions: state.jobTypeOptions,
                   jobSort: state.jobSort,
               },
               ['jobRange', 'defaultFilterRange']
           );
       }
        default:
            return state;
    }
}
